import { useState, useEffect, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Input, TextArea, Select, TextAreaAdvanced, InputImageUploadSimple } from "../../../Layout/Forms/Form";
import Location from '../../Nightspots/Form/Location/Location';

const FormEditLocation = ({ show, handleModalhide, info, handlerSubmit }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        form: {
            location: {
                address_components: [],
                formatted_address: "",
                geometry: {
                    lng: "",
                    lat: "",
                },
                place_id: "",
            }
        },
        errors: [],
    });
    useEffect(() => {
        if (show && info) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    location: info
                }
            })
        }
    }, [show])

    const handleChangeInputsLocation = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    location: {
                        ...e,
                    },
                },
            });
        }
    };

    const handleSubmitForm = () => {
        handlerSubmit(state.form.location)
    }


    return (

        <>
            <Modal
                show={show}
                onHide={handleModalhide}
                centered
                contentClassName="campaign-card border-0 shadow-lg"
                size="lg"
            >
                <Modal.Header className="border-0 pb-0 d-flex align-items-center">
                    <div className="d-flex align-items-center gap-3">
                        <div className="icon-box-premium" style={{ width: '45px', height: '45px', fontSize: '1.2rem' }}>
                            <i className="fa-solid fa-map-pin text-primary"></i>
                        </div>
                        <div>
                            <Modal.Title className="fs-5 fw-bold mb-0">Editar Localização</Modal.Title>
                            <p className="text-muted small mb-0">Define onde o teu evento vai acontecer.</p>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center ms-auto border-0 bg-white bg-opacity-10 hover-scale"
                        onClick={handleModalhide}
                        style={{
                            width: '36px',
                            height: '36px',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <i className="fa-solid fa-xmark text-white fs-5"></i>
                    </button>
                </Modal.Header>

                <Modal.Body className="py-4">

                    <div className="row">
                        <div className="col-12">
                            <Location
                                visible
                                handleChangeForm={(e) => handleChangeInputsLocation(e)}
                                form={state.form.location}
                            />
                        </div>
                    </div>

                </Modal.Body>

                <Modal.Footer className="border-0 pt-0">
                    <button
                        className="btn-action btn-campaign-primary py-2 px-5 w-auto"
                        onClick={() => handleSubmitForm()}
                    >
                        GUARDAR
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default FormEditLocation;